import { API_PATH_PELAKSANAAN_CONFIG } from 'api/kinerja/useAPIKinerja'
import { useKinerjaApi } from 'api/kinerja/utils/api'

import type { UseQueryOptions } from 'react-query'
import type { ResponseGetHolidayDates } from 'types/holiday'

export const API_GET_HOLIDAY_DATES = `${API_PATH_PELAKSANAAN_CONFIG}/HOLIDAY_DATE`

export function useAPIGetHolidayDates({
  params,
  options,
}: {
  params: { year: number }
  options?: UseQueryOptions<ResponseGetHolidayDates>
}) {
  return useKinerjaApi<ResponseGetHolidayDates>(`${API_GET_HOLIDAY_DATES}`, {
    ...options,
    axiosConfig: {
      params: {
        skp_year: params.year,
      },
    },
  })
}
